module.exports = __webpack_public_path__ + "img/bookmark-white.48490daa.svg";